import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { CPropertyListFilterKeys } from "../util/propertyListFilter";
import { ICardProperty } from "@rf-model/card-property.model";
import {
  Map,
  InfoWindow,
  Marker,
  MapCameraChangedEvent,
  MapEvent
} from "@vis.gl/react-google-maps";
import {
  DEFAULT_LAT,
  DEFAULT_LNG,
  DEFAULT_ZOOM
} from "@rf-l1/map-v2/components/MxMapViewer";
import MxCPropertyContentHeader from "@rf-l1/cards/property/property-elements-card/MxCPropertyContentHeader";
import MxCPropertyPicture from "@rf-l1/cards/property/property-elements-card/MxCPropertyPicture";
import MxCPropertyRainbowLabel from "@rf-l1/cards/property/property-elements-card/MxCPropertyRainbowLabel";
import MxCPropertyContentDetailLarge from "@rf-l1/cards/property/property-elements-card/MxCPropertyContentDetailLarge";
import { Grid, styled } from "@mui/material";
import MxCPropertyTitle from "@rf-l1/cards/property/property-elements-card/MxCPropertyTitle";
import MxCPropertyPrice from "@rf-l1/cards/property/property-elements-card/MxCPropertyPrice";
import MxCPropertyLocation from "@rf-l1/cards/property/property-elements-card/MxCPropertyLocation";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { useNavigate } from "react-router-dom";
import { getConditionStatusLabel } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-condition-status-label";
import { C_CONDICTION_PROPERTY } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";

interface PropertyListCardMapProps {
  mapId: string;
  properties: ICardProperty[];
  resetKey: number;
}
const MARKER_ICON_DEFAULT =
  "data:image/svg+xml;base64,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";

const MARKER_ICON_PROJECT =
  "data:image/svg+xml;base64,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 bGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5LjY2NjUgMjFIMjAuNDk5OCIgc3Ryb2tlPSIjRkZGQUZBIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuMTY2NSAyNS4zNzVWMTEuMzc1QzEyLjE2NjUgMTAuOTEwOSAxMi4zNDIxIDEwLjQ2NTggMTIuNjU0NyAxMC4xMzc2QzEyLjk2NzIgOS44MDkzNyAxMy4zOTExIDkuNjI1IDEzLjgzMzIgOS42MjVIMjIuMTY2NUMyMi42MDg1IDkuNjI1IDIzLjAzMjUgOS44MDkzNyAyMy4zNDUgMTAuMTM3NkMyMy42NTc2IDEwLjQ2NTggMjMuODMzMiAxMC45MTA5IDIzLjgzMzIgMTEuMzc1VjI1LjM3NSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODRfNzEiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4IDcpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+";

const PropertyListCardMap = memo(
  ({ mapId, properties, resetKey }: PropertyListCardMapProps) => {
    const navigate = useNavigate();
    const { setValue, getValues } = useFormContext();
    const [hoveredProperty, setHoveredProperty] = useState<ICardProperty | null>(
      null
    );
    const ZOOM_THRESHOLD = 10;

    // Actualizar filtro por área basado en el zoom (y bounds actuales)
    const handleCameraOrZoomChanged = useCallback(
      (ev: MapCameraChangedEvent) => {
        const { bounds, zoom } = ev.detail;
        if (!bounds) return;
        if (zoom < ZOOM_THRESHOLD) {
          // Limpiar área si salimos por debajo del umbral
          if (getValues(CPropertyListFilterKeys.area)) {
            setValue(CPropertyListFilterKeys.area, "", {
              shouldDirty: true,
              shouldTouch: false,
              shouldValidate: false
            });
          }
          return;
        }
        // Convertimos bounds a formato "NE.lat,NE.lng,SW.lat,SW.lng"
        const neLat = bounds.north;
        const neLng = bounds.east;
        const swLat = bounds.south;
        const swLng = bounds.west;
        const areaStr = `${neLat},${neLng},${swLat},${swLng}`;
        if (getValues(CPropertyListFilterKeys.area) !== areaStr) {
          setValue(CPropertyListFilterKeys.area, areaStr, {
            shouldDirty: true,
            shouldTouch: false,
            shouldValidate: false
          });
        }
      },
      [getValues, setValue]
    );

    const handleMarkerMouseOver = useCallback((property: ICardProperty) => {
      setHoveredProperty(property);
      document.getElementById(`${property.id}-property`)?.scrollIntoView({
        behavior: "smooth"
      });
    }, []);

    const handleMarkerMouseOut = useCallback(() => {
      setHoveredProperty(null);
    }, []);

    const handleShowDetail = (id: number) => {
      const path = `/realestates/detail/${id}`;
      if (window.innerWidth > 768) {
        window.open(path, "_blank");
      } else {
        navigate(path);
      }
    };
    const infoWindowPosition = useMemo(() => {
      if (!hoveredProperty) return null;
      return {
        lat: hoveredProperty.lat,
        lng: hoveredProperty.lng
      };
    }, [hoveredProperty]);

    const validProperties = useMemo(
      () =>
        properties.filter(
          item => Number.isFinite(item.lat) && Number.isFinite(item.lng)
        ),
      [properties]
    );

    const markerOptionsFactory = useCallback((isProject: boolean) => {
      const url = isProject ? MARKER_ICON_PROJECT : MARKER_ICON_DEFAULT;

      if (typeof window !== "undefined" && window.google) {
        return {
          icon: {
            url,
            scaledSize: new window.google.maps.Size(35, 40),
            anchor: new window.google.maps.Point(17.5, 40)
          }
        } as google.maps.MarkerOptions;
      }

      return {
        icon: url
      } as google.maps.MarkerOptions;
    }, []);

    const isFirstReset = useRef(true);

    // Reset local highlighting y área al recibir resetKey (excepto en el montaje inicial)
    useEffect(() => {
      if (isFirstReset.current) {
        isFirstReset.current = false;
        return;
      }
      setHoveredProperty(null);
      const currentArea = getValues(CPropertyListFilterKeys.area);
      if (currentArea) {
        setValue(CPropertyListFilterKeys.area, "", {
          shouldDirty: true,
          shouldTouch: false,
          shouldValidate: false
        });
      }
    }, [getValues, resetKey, setValue]);

    // Al arrastrar y soltar (dragend) actualizar el área
    const handleDragEnd = useCallback(
      (ev: MapEvent) => {
        const zoom = ev.map.getZoom() ?? 0;
        const bounds = ev.map.getBounds()?.toJSON();
        if (!bounds) return;
        if (zoom < ZOOM_THRESHOLD) {
          if (getValues(CPropertyListFilterKeys.area)) {
            setValue(CPropertyListFilterKeys.area, "", {
              shouldDirty: true,
              shouldTouch: false,
              shouldValidate: false
            });
          }
          return;
        }
        const areaStr = `${bounds.north},${bounds.east},${bounds.south},${bounds.west}`;
        if (getValues(CPropertyListFilterKeys.area) !== areaStr) {
          setValue(CPropertyListFilterKeys.area, areaStr, {
            shouldDirty: true,
            shouldTouch: false,
            shouldValidate: false
          });
        }
      },
      [getValues, setValue]
    );

    return (
      <div id={mapId} style={{ height: "100%", position: "relative" }}>
        <Map
          key={resetKey}
          defaultZoom={DEFAULT_ZOOM}
          defaultCenter={{ lat: DEFAULT_LAT, lng: DEFAULT_LNG }}
          gestureHandling={"greedy"}
          disableDefaultUI={true}
          onZoomChanged={handleCameraOrZoomChanged}
          onDragend={handleDragEnd}
          style={{ height: "100%", position: "relative" }}
        >
          {validProperties.map(item => (
            <Marker
              key={item.id}
              position={{
                lat: item.lat,
                lng: item.lng
              }}
              draggable={false}
              options={markerOptionsFactory(
                Boolean(item.permissionsProps?.isProject)
              )}
              onClick={() => handleMarkerMouseOver(item)}
              // onMouseOut={handleMarkerMouseOut}
            />
          ))}

          {hoveredProperty && infoWindowPosition && (
            <C>
              <InfoWindow
                position={infoWindowPosition}
                pixelOffset={[0, -32]}
                onCloseClick={() => setHoveredProperty(null)}
              >
                <PropertyHoverCard
                  {...hoveredProperty}
                  onGoToDetail={handleShowDetail}
                />
              </InfoWindow>
            </C>
          )}
        </Map>
      </div>
    );
  }
);

export default memo(PropertyListCardMap);

const C = styled("div")<{}>(({}) => ({
  "& .gm-style-iw": {
    padding: "0 !important"
  },
  "& .gm-style-iw-d": {
    overflow: "hidden !important",
    padding: "0 !important"
  },
  "& .gm-style-iw-chr": {
    display: "none !important"
  }
}));

export interface MxCardPropertySmall extends ICardProperty {
  onGoToDetail?: (id: number) => void;
}

const PropertyHoverCard = (props: MxCardPropertySmall) => {
  const conditionLabel = getConditionStatusLabel(
    props.conditionStatus,
    props.businessType
  );
  const conditionColor =
    conditionLabel === C_CONDICTION_PROPERTY.NEW.name ? "#8CC63F" : "red";

  return (
    <Grid
      maxWidth={300}
      pb={0.5}
      className={`card-property `}
      sx={{
        cursor: "pointer",
        margin: "0 auto"
      }}
    >
      <MxCPropertyContentHeader>
        {Boolean(props.pictures) && <MxCPropertyPicture pictures={props.pictures} />}

        {Boolean(conditionLabel) && (
          <MxCPropertyRainbowLabel
            children={conditionLabel}
            background={conditionColor}
            variant="top-right"
          />
        )}

        {Boolean(props.isCollection) && (
          <MxCPropertyRainbowLabel
            children="Collection"
            background="red"
            variant="bottom-left"
          />
        )}

        {Boolean(props.id) && (
          <MxCPropertyRainbowLabel
            children={`ID: ${props.id}`}
            variant="bottom-right"
            // onClick={handleCopyOnClick}
          />
        )}
      </MxCPropertyContentHeader>

      <MxCPropertyContentDetailLarge container rowGap={1}>
        {Boolean(props?.title) && (
          <Grid item xs={12}>
            <MxCPropertyTitle children={props.title} />
          </Grid>
        )}

        {Boolean(props?.prices?.length) && (
          <Grid container my={0.8} rowGap={0.5}>
            {props?.prices?.map((price, i) => (
              <Grid item xs={12} key={i}>
                <MxCPropertyPrice {...price} />
              </Grid>
            ))}
          </Grid>
        )}

        {Boolean(props?.location) && (
          <Grid item xs={12}>
            <MxCPropertyLocation location={props.location ?? ""} />
          </Grid>
        )}
      </MxCPropertyContentDetailLarge>
      <Grid item xs={12} container>
        <MxButton2
          onClick={() => props.onGoToDetail && props.onGoToDetail(Number(props.id))}
          sx={{
            margin: "0 auto"
          }}
          variant="contained"
          bgColor="primary.main"
        >
          Ver detalle
        </MxButton2>
      </Grid>
    </Grid>
  );
};
